

































import {Component, Prop, Vue} from "nuxt-property-decorator";

@Component({
  components: {},

  computed: {
    isShowBredcrumb: function (this: PagePagination) {
      let avaiblesPatsh = 0;

      this.breadcrumbs.map((item: any) => {
        if (!!item.title) {
          avaiblesPatsh++;
        }
      });

      return Boolean(avaiblesPatsh >= 2);
    },
  },
})
export default class PagePagination extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  private readonly breadcrumbs!: any[];
}
